module.exports = __webpack_public_path__ + "img/bg-calendar.c9d8a783.png";